<section [ngStyle]="styles" blazeElementSelectionHelper [isInEditor]="isInEditor">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align?.horizontal"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      [position]="props?.content?.title?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [verticalAlign]="labelVerticalAlign"
      [width]="props?.content?.title?.width"
    >
      {{ labelText }}
    </blaze-element-label>
  }
  <div class="input allow-selection" [ngStyle]="inputWrapperStyles">
    @let noValue = isNullishFn(value);
    <div class="input-container-wrapper">
      <div
        class="input-container format-{{ format }}"
        (click)="onValueClick()"
        [ngClass]="inputContainerClasses$ | async"
        [class.opacity-50]="noValue"
      >
        <ng-container
          *ngTemplateOutlet="
            format === 'image' ? imgTpl : format === 'timezone' ? timezoneTpl : textTpl;
            context: { $implicit: value, noValue }
          "
        />
      </div>
    </div>
  </div>
</section>

<!--
Keep content of this template in one line!
It is needed to prevent whitespaces at the beginning of text in paragraph mode.
-->
<ng-template #textTpl let-value let-noValue="noValue">
  @let formattedValue =
    !noValue
      ? (value
        | formatValue
          : format
          : {
              precision: precision,
              currency: currency,
              durationFormat: duration,
              dateFormat: dateFormat,
              dateTimeFormat: dateTimeFormat,
              isArrayValue: isArrayValue,
              culture: culture,
            })
      : placeholder;
  @if (format !== 'richText' && format !== 'markdown') {
    <span [ngStyle]="contentStyles">{{ formattedValue }}</span>
  } @else {
    <span class="html-content" [ngStyle]="contentStyles" [innerHTML]="formattedValue"></span>
  }
</ng-template>

<ng-template #timezoneTpl let-value let-noValue="noValue">
  <span [ngStyle]="contentStyles">{{
    !noValue ? (value | formatTimeZone | async) : placeholder
  }}</span>
</ng-template>

<ng-template #imgTpl let-value>
  <span [ngStyle]="contentStyles">
    <img
      [src]="value"
      alt=""
      imgError="assets/images/icon-image-32.svg"
      class="col-img"
      loading="lazy"
    />
  </span>
</ng-template>
